import axios from "axios";
import { useEffect, useState } from "react";


const useUser = (email) => {
    const [userc, setUserc] = useState({});
    useEffect(() => {
        axios.get(`https://tripaide-server.onrender.com/users/${email}`)
            .then(res => {
                setUserc(res.data);
                //console.log(res.data);
            })
    }, [email]);
    return [userc, setUserc]
};

export default useUser;